<template>
  <div class="view-container">
    <SettlementTotalSummary class="mt-6 mb-6" />
    <History />
  </div>
</template>

<script>
import SettlementTotalSummary from '@/components/settlement/TotalSummary.vue'
import History from '@/components/settlement/History.vue'
export default {
  components: { SettlementTotalSummary, History },
}
</script>
